export enum TemperatureType {
  CELSIUS = 'C',
  FAHRENHEIT = 'F',
}

export const getCurrentTemperatureType = (
  tempUnit: string | undefined,
): string => {
  for (const value in TemperatureType) {
    // @ts-ignore
    if (TemperatureType[value] === tempUnit) {
      return tempUnit!;
    }
  }

  return TemperatureType.CELSIUS;
};

export const getTemperatureTypeArray = (): any => {
  let res = [];

  res.push({
    ref: TemperatureType.CELSIUS,
    label: 'temperature.' + TemperatureType.CELSIUS,
  });

  res.push({
    ref: TemperatureType.FAHRENHEIT,
    label: 'temperature.' + TemperatureType.FAHRENHEIT,
  });

  return res;
};
